var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNavigateShop(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "navigate-shop",
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.55 0.5H10.35C10.05 0.5 9.75 0.725 9.75 0.95V2.075C9.75 2.375 10.05 2.75 10.35 2.75H13.275C13.65 2.75 13.8 3.125 13.575 3.35L7.2 9.725C6.975 9.95 6.975 10.325 7.2 10.55L8.025 11.375C8.25 11.6 8.625 11.6 8.85 11.375L15.225 5C15.375 4.7 15.75 4.85 15.75 5.225V8.225C15.75 8.525 16.05 8.9 16.35 8.9H17.475C17.775 8.9 18.075 8.6 18.075 8.225V1.025C18 0.725 17.85 0.5 17.55 0.5Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.825 9.35L11.55 10.7C11.325 10.925 11.175 11.15 11.175 11.525V15.8C11.175 16.1 10.875 16.4 10.575 16.4H2.85C2.475 16.25 2.25 15.95 2.25 15.725V7.85C2.25 7.55 2.475 7.25 2.85 7.25H7.2C7.5 7.25 7.8 7.175 8.025 6.95L9.3 5.675C9.45 5.45 9.3 5 8.925 5H1.5C0.675 5 0 5.675 0 6.5V17C0 17.825 0.675 18.5 1.5 18.5H12C12.825 18.5 13.5 17.825 13.5 17V9.575C13.5 9.2 13.125 9.05 12.825 9.35Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavigateShop);
export default __webpack_public_path__ + "static/media/navigate-shop.1e881f74aa19780100ff7ea68a19d5fe.svg";
export { ForwardRef as ReactComponent };